module.exports = __webpack_public_path__ + "img/gotoup.7fee49c6.gif";